import KeenSlider from "keen-slider";

function ThumbnailPlugin(main) {
  return (slider) => {
    function removeActive() {
      slider.slides.forEach((slide) => {
        slide.classList.remove("active");
      });
    }
    function addActive(idx) {
      slider.slides[idx].classList.add("active");
    }

    function addClickEvents() {
      slider.slides.forEach((slide, idx) => {
        slide.addEventListener("click", () => {
          main.moveToIdx(idx);
        });
      });
    }

    slider.on("created", () => {
      addActive(slider.track.details.rel);
      addClickEvents();
      main.on("animationStarted", (main) => {
        removeActive();
        const next = main.animator.targetIdx || 0;
        addActive(main.track.absToRel(next));
        slider.moveToIdx(next);
      });
    });
  };
}
var slider = [8];
var thumbnails = [8];

for (var i = 1; i <= 8; i++) {
  slider[i - 1] = new KeenSlider("#main-slider" + String(i));
  thumbnails[i - 1] = new KeenSlider(
    "#thumbnail" + String(i),
    {
      initial: 0,
      slides: {
        perView: "auto",
      },
    },
    [ThumbnailPlugin(slider[i - 1])]
  );
}
